import { render } from "./StoreTable.vue?vue&type=template&id=39a0ba94"
import script from "./StoreTable.vue?vue&type=script&lang=js"
export * from "./StoreTable.vue?vue&type=script&lang=js"

import "./StoreTable.vue?vue&type=style&index=0&id=39a0ba94&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__